export default __webpack_public_path__ + "static/piscina-torres-3f6c5bb08cd7a3b5a263a42a16f041f8.jpg";